<template>
  <div class="search-container align-center flex-wrap">
    <div v-if="isInput" class="demo-input-suffix">
      <el-input
        v-model="searchVal"
        :placeholder="`请输入${inputLabe}搜索`"
        clearable
        @keyup.enter.native="searchBtn"
      />
    </div>

    <div v-if="isDate" class="demo-input-suffix">
      <date-picker
        v-model="dateVal"
        type="daterange"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
      />
    </div>

    <slot name="search" />

    <div class="search-btns">
      <el-button class="search-btn" type="text" @click="searchBtn"> 搜索 </el-button>
      <slot name="btns" />
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker/index.vue";
export default {
  name: "Search",
  components: {
    DatePicker
  },
  props: {
    // 是否展示默认输入框
    isInput: {
      type: Boolean,
      default: true
    },
    inputLabe: {
      type: String,
      default: "关键字"
    },
    value: {
      type: String,
      default: ""
    },
    isDate: {
      type: Boolean,
      default: false
    },
    // 是否有修改可点击搜索
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldValue: this.value,
      dateVal: null,
      oldDateVal: null
    };
  },

  computed: {
    searchVal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        return value;
      }
    }
  },

  methods: {
    searchBtn() {
      if (
        this.isSearch ||
        this.oldDateVal !== (this.dateVal && this.dateVal.join(",")) ||
        this.searchVal !== this.oldValue
      ) {
        this.oldValue = this.searchVal;
        this.oldDateVal = this.dateVal && this.dateVal.join(",");
        this.$emit("searchBtn", this.searchVal, this.dateVal);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.search-container {
  // justify-content: flex-end;
  & > div {
    margin: 5px 10px 5px 0;
  }
}

::v-deep .demo-input-suffix {
  .el-input__inner,
  .el-range-input {
    border-radius: 6px;
    // height: 36px;
    background: #f1f1f1;
    border-radius: 20px;
    border: none;
  }
  .el-input__icon {
    line-height: 30px;
  }
}

::v-deep .search-btns {
  margin: 5px 0;
  // display: flex;
  // align-self: end;
  .search-btn {
    font-size: 20px;
    color: rgba(27, 156, 238, 1);
    margin-right: 20px;
    padding: 9px 0;
  }
  // .is-plain {
  //   background-color: #fff;
  //   border-color: #409eff;
  //   color: #409eff;
  //   &:hover {
  //     background-color: #409eff;
  //     color: #fff;
  //   }
  // }
}
</style>
